import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Components
import RPReportFiles from '../../../../../../shared/components/Extent/RPReportFiles'
import SparePartPremiumList from '../PremiumList'

// Utils
import { hasSubscriptionPermission, hasAccess } from '../../../../../../utils/auth'
import { translation } from '../../../../../../utils/helpers'

// Elements
import Icon from '../../../../../../shared/elements/icon'
import Grid from '../../../../../../shared/elements/grid'
import Inline from '../../../../../../shared/elements/inline'
import Divider from '../../../../../../shared/elements/divider'
// import LabelWrapper from '../../../../../../shared/elements/labelWrapper'
import { SparePartModuleIcons } from '../../../../../../shared/elements/icons'

class SparePartList extends Component {
  constructor (props) {
    super(props)
    this.state = {}

    this.renderPart = this.renderPart.bind(this)
    this.renderPartNew = this.renderPartNew.bind(this)
    this.renderTypeOfPart = this.renderTypeOfPart.bind(this)
    this.getSortedPartsNew = this.getSortedPartsNew.bind(this)
    this.renderRPReportFiles = this.renderRPReportFiles.bind(this)
    this.getLowestValuedStatusSortOrder = this.getLowestValuedStatusSortOrder.bind(this)
  }

  renderTypeOfPart (type) {
    let parttype = ''
    if (type === 1) parttype = '(' + translation('1443') + ')'
    if (type === 2) parttype = '(L)'
    if (type === 3) parttype = '(M)'
    if (type === 4) parttype = '(KG)'
    return parttype
  }

  renderPart (part, key) {
    const num = part.PartNumber
    const text = part.Name
    const count = part.Count || part.Qty
    const type = part.CountType || part.Unit

    if (key === 0) {
      return (
        <div key={key}>
          <div className='sparePartItem'>
            <div className='sparePartName sparepartTitle'>{translation('14819')}</div>
            <div className='sparePartAmount sparepartTitle'>{translation('385')}</div>
          </div>
          <div className='sparePartItem sparePartView'>
            <div className='sparePartName'>
              <div>{num}&nbsp;</div>
              <div>{text} <font className='sparepartTitle'>{this.renderTypeOfPart(type)}</font></div>
            </div>
            <div className='sparePartAmount'>{count}</div>
          </div>
        </div>
      )
    } else {
      return (
        <div key={key} className='sparePartItem sparePartView'>
          <div className='sparePartName'>
            <div>{num}&nbsp;</div>
            <div>{text} <font className='sparepartTitle'>{this.renderTypeOfPart(type)}</font></div>
          </div>
          <div className='sparePartAmount'>{count}</div>
        </div>
      )
    }
  }

  getSortedPartsNew (parts) {
    return parts.sort((partA, partB) => {
      const a = this.getLowestValuedStatusSortOrder(partA.Status)
      const b = this.getLowestValuedStatusSortOrder(partB.Status)

      return a - b
    })
  }

  getLowestValuedStatusSortOrder (status) {
    if ((status & 1) === 1) {
      return 100 // sort order
    } else if ((status & 8) === 8) {
      return 200
    } else if ((status & 64) === 64) {
      return 300
    } else if ((status & 32) === 32) {
      return 400
    } else if ((status & 4) === 4) {
      return 500
    } else if ((status & 16) === 16) {
      return 600
    } else if ((status & 2) === 2) {
      return 700
    }
  }

  renderPartNew (item, key) {
    // const icon = ((item.Status & (4 | 16)) !== 0) ? SparePartModuleIcons.OK : SparePartModuleIcons.Warning
    let icon = SparePartModuleIcons.Warning
    // 127 - ((2 + 4 + 16) === NotInUse | InStock | Received)
    if ((item.Status & 105) === 0) {
      icon = SparePartModuleIcons.OK
    }

    let statusText = ''
    const sortOrderValue = this.getLowestValuedStatusSortOrder(item.Status)
    switch (sortOrderValue) {
      case 100:
        statusText = '14796' // Not ordered
        break
      case 200:
        statusText = '16535' // Not received
        icon = SparePartModuleIcons.Attention
        break
      case 300:
        statusText = '16454' // Incorrect
        break
      case 400:
        statusText = '16453' // Defective
        break
      case 500:
        statusText = '14799' // In stock
        break
      case 600:
        statusText = '16452' // Received
        break
      case 700:
        statusText = '16449' // Not in use
        break
    }
    statusText = `(${translation(statusText)})`

    return (
      <Grid cols='24px auto max-content' spacing={1} key={key}>
        <Icon icon={icon} />
        <Grid cols='auto' nogap>
          <Inline spacing={0}>
            <span>{item.SparePartNumberAlias || item.OriginalSparePartNumber} {statusText}</span>
            {item.UrgentDelivery && <Icon icon={SparePartModuleIcons.Urgent} ariaText={translation('16578')} ariaPos='top' injectSvg />}
          </Inline>
          <span>{item.Description}&nbsp;</span>
        </Grid>
        <span>{item.Count}</span>
      </Grid>
    )
  }

  renderRPReportFiles () {
    return (
      <RPReportFiles
        order={this.props.order}
        renderSparePart
        showDates
      />
    )
  }

  render () {
    let hasProPremium = hasSubscriptionPermission(this.props.auth, 30)
    const isCustomer = hasAccess([4], this.props.auth.user.UserType)
    const spareParts = this.props.order.SparePartItems
    const rpReport = this.props.order.RpReport
    const newSpareParts = this.props.order.NewSparePartItems

    if (newSpareParts.length > 0 && hasProPremium && !isCustomer) {
      return (
        <div>
          {<Divider size={2} />}
          <SparePartPremiumList orderId={this.props.order.Id} />
        </div>
      )
    } else if (spareParts.length > 0) {
      return (
        <div>
          {(this.props.auth.user.UserType !== 4) && <Divider size={2} />}
          {this.props.order.SparePartItems.map(this.renderPart)}
        </div>
      )
    } else if (rpReport && rpReport.SparePartLines.length > 0) {
      return (
        <div>
          {(this.props.auth.user.UserType !== 4) && <Divider size={2} />}
          {this.renderRPReportFiles()}
          {this.props.order.RpReport && this.props.order.RpReport.SparePartLines.map(this.renderPart)}
        </div>
      )
    }

    return null
  }
}

SparePartList.propTypes = {
  order: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  showRpFiles: PropTypes.bool.isRequired
}

SparePartList.defaultProps = {
  showRpFiles: false
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {})(SparePartList)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/SpareParts/List/index.js